import { render, staticRenderFns } from "./pushManage.vue?vue&type=template&id=39d280e6&scoped=true&"
import script from "./pushManage.vue?vue&type=script&lang=js&"
export * from "./pushManage.vue?vue&type=script&lang=js&"
import style0 from "./pushManage.vue?vue&type=style&index=0&id=39d280e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d280e6",
  null
  
)

export default component.exports